const defaultConfig = Object.entries(process.env).reduce(
  (conf, [key, value]) => {
    if (key.startsWith('REACT_APP_')) {
      conf[key.replace('REACT_APP_', '')] = value;
    }
    return conf;
  },
  {
    DASHIFI_URL: window.location.origin,
  }
);

const baseEndpointPath = 'api/v1';

const HOMEROOM = 'HOMEROOM';
const ADMINIFI = 'ADMINIFI';
const NEXT = 'NEXT';

const getAuthApp = app => {
  let url = defaultConfig.ADMINIFI_URL;
  let clientId = defaultConfig.ADMINIFI_CLIENT_ID;
  let redirectUri = `${window.location.origin}/callback`;

  if (app === HOMEROOM) {
    url = defaultConfig.HOMEROOM_PLATFORM_URL;
    clientId = defaultConfig.HOMEROOM_CLIENT_ID;
    redirectUri = `${window.location.origin}/callback-homeroom`;
  }

  if (app === NEXT) {
    url = defaultConfig.NEXT_URL;
    clientId = defaultConfig.NEXT_CLIENT_ID;
    redirectUri = `${window.location.origin}/callback-next`;
  }

  return { url, clientId, redirectUri };
};

const createEndpointPath = (base, version = 'v1') => `${base}/api/${version}`;

const apiBasePath = {
  EVALUFI: createEndpointPath(defaultConfig.EVALUFI_URL),
  CERTIFICATE_SERVICE: createEndpointPath(defaultConfig.CERTIFICATE_SERVICE_URL),
  CONTENT_SERVICE: createEndpointPath(defaultConfig.CONTENT_SERVICE_URL),
  COMPLIANCE: createEndpointPath(defaultConfig.COMPLIANCE_URL),
  ADMINIFI: createEndpointPath(defaultConfig.ADMINIFI_URL),
  HOMEROOM: createEndpointPath(defaultConfig.HOMEROOM_PLATFORM_URL, 'v3'),
  NOTIFI: createEndpointPath(defaultConfig.NOTIFI_URL),
};

const config = {
  ...defaultConfig,
  apiBasePath,
  baseEndpointPath,
  getAuthApp,
  HOMEROOM,
  ADMINIFI,
  NEXT,
};

export default config;
export { defaultConfig };
